<template>

    <div class="row">
        <div class="col-md-6 col-md-offset-3">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Gebruikersgroepen</h2>
                    <div class="box-tools">
                        <router-link
                            class="btn btn-primary btn-xs"
                            :to="{name:'hr.usergroups.add'}"
                            v-tooltip.bottom="'Gebruikersgroep toevoegen'"
                        >
                            <i class="mdi mdi-plus"></i>
                            <span class="sr-only">Gebruikersgroep toevoegen</span>
                        </router-link>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Naam</th>
                                <th>Partnergroep</th>
                                <th class="text-right">Tarief</th>
                                <th class="text-center">Productiviteits percentage</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="getHrUsergroups.length === 0"><td colspan="5">Er zijn geen gebruikersgroepen gevonden</td></tr>
                            <tr
                                v-for="usergroup in getHrUsergroups"
                                :id="'row-' + usergroup.uuid"
                            >
                                <td>{{ usergroup.name }}</td>
                                <td>{{ usergroup.is_partnergroup === true ? 'Ja' : 'Nee' }}</td>
                                <td class="text-right">{{ usergroup.rate | toCurrency }}</td>
                                <td class="text-center">{{ usergroup.active }}%</td>
                                <td class="text-right">
                                    <div class="btn-group btn-group-xs">
                                        <router-link
                                            :to="{name:'hr.usergroups.show', params:{uuid:usergroup.uuid}}"
                                            class="btn btn-default"
                                            v-tooltip="'Gebruikersgroep bekijken'"
                                        >
                                            <i class="mdi mdi-eye"></i>
                                            <span class="sr-only">Gebruikersgroep bekijken</span>
                                        </router-link>
                                        <router-link
                                            :to="{name:'hr.usergroups.edit', params:{uuid:usergroup.uuid}}"
                                            class="btn btn-primary"
                                            v-tooltip="'Gebruikersgroep bewerken'"
                                        >
                                            <i class="mdi mdi-pencil"></i>
                                            <span class="sr-only">Gebruikersgroep bewerken</span>
                                        </router-link>
                                        <delete-button
                                            :parent-element="'row-' + usergroup.uuid"
                                            :url="route('api.v1.hr.usergroups.destroy', {uuid:usergroup.uuid})"
                                            :name="usergroup.name"
                                            title="Gebruikersgroep"
                                            v-tooltip="'Gebruikersgroep verwijderen'"
                                        ></delete-button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import {mapGetters} from "vuex";

export default {

    computed: {
        ...mapGetters([
            'getHrUsergroups',
        ]),
    },

    metaInfo: {
        title:'Usergroups',
    },

    name:'HrUsergroupsIndex',

}

</script>
